import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPermissionSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-permissions-schemes',
	path: '/jira/settings/issues/permission-schemes-new/:schemeId',
};
